
<template>
  <div class="DataUpdate">
    <div class="titlePage">Estudiantes Inscritos en Grados Ibero</div>
    <va-notification color="info" v-if="addRExito" class="refNoData">Se creo correctamente el Grado solicitado.</va-notification>
    <va-notification color="info" v-if="UpdRExito" class="refNoData">Se actualizo correctamente el Grado solicitado.</va-notification>
    <va-notification color="danger" v-if="refNoUpdate" class="refNoData">La actualizacion del Grado presento un fallo.</va-notification>
    <va-notification color="danger" v-if="refWSUpdate" class="refNoData">El servicio que ejecuta la actualización no se encuentra activo.</va-notification>

    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchGrade
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification
      color="danger"
      id="refNoData"
      class="refNoData noShow"
    >No se encontró información del Grado solicitado.</va-notification>
    <div class="listGrades">
      <DataTableGrades
        :InfoView="this.DLGrades"
        :HeadTable="this.HDGrades"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchGrade from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormupdateGrades from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTableGrades from '@/components/data-tables/DataReportGrade.vue'
import XLSX from 'xlsx'

export default {
  name: 'DataUpdate',
  components: {
    DataTableGrades,
    FormSearchGrade,
    FormupdateGrades,
  },
  data () {
    return {
      AlertValidator: '',
      formSchModel: {
        IdGrade: '',
      },
      formSearch: [
        {
          id: 'Sch_Grade',
          model: 'IdGrade',
          name: 'Grado',
          type: 'input',
          placeholder: 'Grado',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar',
          class: 'col-md-4',
        },
        {
          id: 'Exp_Button',
          type: 'button',
          placeholder: 'Exportar',
          visible: true,
          class: 'col-md-4',
        },
      ],

      Export: [
        {
          Grado: '',
        },
      ],

      HDGrades: [
        {
          id: 'Grado',
          model: 'Grado',
          name: 'Grado',
          type: 'input',
          placeholder: 'Grado',
          values: '',
          class: 'col-md-4',
        },
        {
          id: 'Id_Banner',
          model: 'Id_Banner',
          name: 'Id_Banner',
          type: 'input',
          placeholder: 'Numero Banner',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Numero_Identificacion',
          model: 'Numero_Identificacion',
          name: 'Numero_Identificacion',
          type: 'input',
          placeholder: 'Documento Identidad',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Nombres',
          model: 'Nombres',
          name: 'Nombres',
          type: 'input',
          placeholder: 'Nombres',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Programa',
          model: 'Programa',
          name: 'Programa',
          type: 'input',
          placeholder: 'Programa',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Fecha_Inscripcion',
          model: 'Fecha_Inscripcion',
          name: 'Fecha_Inscripcion',
          type: 'input',
          placeholder: 'Fecha Inscripcion',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Documento',
          model: 'Documento',
          name: 'Documento',
          type: 'button',
          placeholder: 'Documento',
          class: 'col-md-4',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
        {
          id: 'SaberPro',
          model: 'SaberPro',
          name: 'SaberPro',
          type: 'button',
          placeholder: 'SaberPro',
          class: 'col-md-4',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
        {
          id: 'Diploma_Bachiller',
          model: 'Diploma_Bachiller',
          name: 'Diploma_Bachiller',
          type: 'button',
          placeholder: 'Diploma_Bachiller',
          class: 'col-md-4',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
        // {
        //   id: 'Foto',
        //   model: 'Foto',
        //   name: 'Foto',
        //   type: 'button',
        //   placeholder: 'Foto',
        //   class: 'col-md-4',
        //   actionRef: [
        //     {
        //       label: 'Editar',
        //       icon: 'fa-pencil',
        //       action: 'edit',
        //     },
        //   ],
        // },
        {
          id: 'Diploma_Pregrado',
          model: 'Diploma_Pregrado',
          name: 'Diploma_Pregrado',
          type: 'button',
          placeholder: 'Diploma_Pregrado',
          class: 'col-md-4',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
        {
          id: 'Saber11',
          model: 'Saber11',
          name: 'Saber11',
          type: 'button',
          placeholder: 'Saber11',
          class: 'col-md-4',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      DLGrades: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      refValidator: false,
      isNew: false,
    }
  },
  methods: {
    DataToExport: function () {
      this.Export.Grado = this.DLGrades.fields[1].values
    },
    exportExcel: function () {
      this.DataToExport()
      let data = XLSX.utils.json_to_sheet(this.Export)
      const workbook = XLSX.utils.book_new()
      const filename = 'data-grade'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.isNew = false
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
        case 'btn_Exp_Button':
          this.exportExcel()
      }
      this.$refs.obsFieldsSearch.validate()
    },
    ValidatorDates (date1, date2) {
      if (date2 >= date1) { return true } else { return false }
    },
    searchForm () {
      document.getElementById('refNoData').classList.add('noShow')
      this.isNew = false
      let loader = this.$loading.show()
      var ListGrades = IberoHelpers.getInscriptionGradesList(this.$store, this.formSchModel.IdGrade, 0)
      this.renderComponent1 = false
      ListGrades.then(Response => {
        if ((Response.data === undefined) || (Response.data === '')) {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLGrades = Response.data
          } else {
            this.DLGrades = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },
    CancelUser () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('GradeModal')
    },
    limpiaref () {
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      this.refValidator = false
      document.getElementById('refNoData').classList.add('noShow')
    },
    processData: function (dataInf, refdata) {

    },
  },
}
</script>